module.exports = __webpack_public_path__ + "static/media/Icon_Geld_Zurück.47fc708d.svg";